// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2FYEa","inputDescription":"styles_inputDescription__37oVk"};